import React, {useState, useEffect} from 'react'
import {
  Modal,
  Typography,
  IconButton,
  TextField,
  Button,
  AppBar,
  Tab,
  Tabs,
  Table,
  InputLabel,
  Grid,
  FormControl,
  MenuItem,
  Select,
} from '@material-ui/core'

export default function CurrencyFieldType({
  type,
  onChange = (e, key, value, typeId) => {},
  idx,
  fieldData,
  list,
  data,
}) {
  const [showValueField, setShowValueField] = useState(false)
  const [showBetweenField, setShowBetweenField] = useState(false)
  const [sameTypeList, setSameTypeList] = useState([])

  useEffect(() => {
    const filterdData = list.filter(data => type.type === data.type && type.name !== data.name)
    setSameTypeList(filterdData)
  }, [list, type])

  useEffect(() => {
    if (data?.compare_select_one === 'field_value') {
      setShowValueField(true)
    }
    // eslint-disable-next-line
  }, [])

  return (
    <div>
      <Grid row xs={12}>
        <FormControl variant="outlined" style={{minWidth: '100px'}}>
          <Select
            defaultValue={data?.numeric_compare ? data.numeric_compare : ''}
            name="select1"
            onChange={e => {
              onChange(
                e,
                'list_filters_attributes',
                e.target.value,
                'numeric_compare',
                idx,
                '',
                type.id
              )
              if (e.target.value === '<>' || e.target.value === '><') {
                setShowBetweenField(true)
                // setShowValueField(true);
              } else {
                // setShowValueField(false);
                setShowBetweenField(false)
              }
            }}
          >
            <MenuItem value="<">Is less than</MenuItem>
            <MenuItem value="<=">Is less than or equal</MenuItem>
            <MenuItem value="==">Is equal with</MenuItem>
            <MenuItem value=">">Is greater than</MenuItem>
            <MenuItem value=">=">Is greater than or equal</MenuItem>
            <MenuItem value="<>">Is between</MenuItem>
            <MenuItem value="><">Is not between</MenuItem>
          </Select>
        </FormControl>
        <FormControl variant="outlined" style={{minWidth: '100px'}}>
          <Select
            defaultValue={data?.compare_select_one ? data.compare_select_one : ''}
            name="select2"
            onChange={e => {
              onChange(
                e,
                'list_filters_attributes',
                e.target.value,
                'compare_select_one',
                idx,
                '',
                type.id
              )
              if (e.target.value === 'field_value') {
                setShowValueField(true)
              } else {
                setShowValueField(false)
              }
            }}
          >
            <MenuItem value="specific_value">a specific value</MenuItem>
            {type?.show_in_value ? <MenuItem value="field_value">value in</MenuItem> : null}
          </Select>
        </FormControl>
        {showValueField && (
          <>
            {sameTypeList.length > 0 && (
              <FormControl variant="outlined" style={{minWidth: '100px'}}>
                <Select
                  defaultValue={sameTypeList[0].id}
                  onChange={e => {
                    onChange(
                      e,
                      'list_filters_attributes',
                      e.target.value,
                      'compare_value_one',
                      idx,
                      '',
                      type.id
                    )
                  }}
                >
                  {sameTypeList.map((val, id) => {
                    return (
                      <MenuItem value={val.id} key={id}>
                        {val.name}
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
            )}
            <FormControl variant="outlined" style={{minWidth: '100px'}}>
              <Select
                defaultValue={data?.value_shift_one ? data.value_shift_one : ''}
                onChange={e => {
                  onChange(
                    e,
                    'list_filters_attributes',
                    e.target.value,
                    'value_shift_one',
                    idx,
                    '',
                    type.id
                  )
                }}
              >
                <MenuItem value="+">plus</MenuItem>
                <MenuItem value="-">minus</MenuItem>
              </Select>
            </FormControl>
          </>
        )}
      </Grid>
      <Grid xs={12} row>
        {showBetweenField && (
          <>
            <FormControl variant="outlined" style={{minWidth: '100px'}}>
              <Select
                defaultValue={data?.compare_select_two ? data.compare_select_two : ''}
                name="select2"
                onChange={e => {
                  onChange(
                    e,
                    'list_filters_attributes',
                    e.target.value,
                    'compare_select_two',
                    idx,
                    '',
                    type.id
                  )
                  if (e.target.value === 'field_value') {
                    setShowValueField(true)
                  } else {
                    setShowValueField(false)
                  }
                }}
              >
                <MenuItem value="specific_value">a specific value</MenuItem>
                {type?.show_in_value ? <MenuItem value="field_value">value in</MenuItem> : null}
              </Select>
            </FormControl>
            <FormControl variant="outlined">
              <TextField
                variant="outlined"
                className="ap-textfield"
                id="number"
                type="number"
                defaultValue={data?.value_two ? data.value_two : ''}
                onChange={e => {
                  onChange(
                    e,
                    'list_filters_attributes',
                    e.target.value,
                    'value_two',
                    idx,
                    '',
                    type.id
                  )
                }}
              />
            </FormControl>
          </>
        )}
        <FormControl variant="outlined">
          <TextField
            variant="outlined"
            className="ap-textfield"
            defaultValue={data?.value_one ? data.value_one : ''}
            id="number"
            type="number"
            onChange={e => {
              onChange(e, 'list_filters_attributes', e.target.value, 'value_one', idx, '', type.id)
            }}
          />
        </FormControl>
      </Grid>
    </div>
  )
}
